import React from 'react';
import "./navbar.css";
import {useKeycloak} from "@react-keycloak/web";


const Navbar = () => {

    const { keycloak, initialized } = useKeycloak();

    const token = keycloak.token;

    let userRoleCheck = keycloak.tokenParsed.realm_access.roles.find(e => e === "CoPCheck");
    let userRoleReport = keycloak.tokenParsed.realm_access.roles.find(e => e === "CoPReport");
    let userRole;

    if(userRoleCheck === "CoPCheck" && userRoleReport ==="CoPReport")
        userRole = "Super user";
    else
        userRole = "User";

    let version;
    let url = window.location.href
    let arr = url.split("/");
    url = arr[0] + "//" + arr[2] + "/version";

    //get app version
    fetch(url)
        .then(async res => res.text())
        .then(text => {
            version = text;
            document.getElementById("versionNumber").innerHTML = version;
        })
        .catch(err => console.error(err))

    console.log("App version: " + version);

    const toggleSidebar = () => {
        const sidebar = document.getElementById("sidebarMenu");
        const manualCoPCheckText = document.getElementById("manualCoPCheckText");
        const reportsText = document.getElementById("reportsText");
        if (sidebar !== null) {
            if (sidebar.style.width === "700%") {
                sidebar.style.width = "100%";
                manualCoPCheckText.style.display = "none";
                reportsText.style.display = "none";
            } else {
                sidebar.style.width = "700%";
                manualCoPCheckText.style.fontSize = "4.8vw";
                reportsText.style.fontSize = "4.8vw";
                setTimeout(() => {
                    manualCoPCheckText.style.display = "inline";
                    reportsText.style.display = "inline";
                }, 200);
            }
        }
    };

    // if(keycloak.tokenParsed != null) {
    //     console.log(token);
    //     console.log("USER EMAIL: " + keycloak.tokenParsed.email);
    //     console.log("USER NAME: " + keycloak.tokenParsed.name);
    // }

    // if(keycloak.tokenParsed!= null) {
    //     console.log("----------- " +JSON.stringify(keycloak.tokenParsed.realm_access.roles));
    // }

    return (
        <nav className="navbar navbar-light">
            <div className="sidebarToggleBtnContainer">
                <button id="sidebarToggleBtn" onClick={toggleSidebar}>
                    <i className="fas fa-bars fa-fw"></i>
                </button>
            </div>
            <div className="logo-homepage bg-white">
                <img
                    className="img-fluid logo-homepage-img"
                    src="/xbp-logo.png"
                    alt="Exela Logo"
                    loading="lazy"
                />
            </div>
            <div className="">
                {/*<div className="dropdown">*/}
                {/*    <a*/}
                {/*        className="text-reset me-3 dropdown-toggle hidden-arrow"*/}
                {/*        href="#"*/}
                {/*        id="navbarDropdownMenuLink"*/}
                {/*        role="button"*/}
                {/*        data-mdb-toggle="dropdown"*/}
                {/*        aria-expanded="false"*/}
                {/*    >*/}
                {/*        <i className="fas fa-bell"></i>*/}
                {/*        <span className="badge rounded-pill badge-notification bg-danger">1</span>*/}
                {/*    </a>*/}
                {/*    <ul*/}
                {/*        className="dropdown-menu dropdown-menu-end"*/}
                {/*        aria-labelledby="navbarDropdownMenuLink"*/}
                {/*    >*/}
                {/*        <li>*/}
                {/*            <a className="dropdown-item" href="#">Some news</a>*/}
                {/*        </li>*/}
                {/*        <li>*/}
                {/*            <a className="dropdown-item" href="#">Another news</a>*/}
                {/*        </li>*/}
                {/*        <li>*/}
                {/*            <a className="dropdown-item" href="#">Something else here</a>*/}
                {/*        </li>*/}
                {/*    </ul>*/}
                {/*</div>*/}
                <div className="dropdown d-flex align-items-center">
                    <i className="fa-solid fa-circle-user"></i>
                    <div className="user">
                        <p className="user-name">{
                            keycloak.tokenParsed.name
                        }</p>
                        <p className="user-role">
                            {userRole}
                        </p>
                        <p id="versionNumber"/>
                    </div>
                    {/*<a*/}
                    {/*    className="dropdown-toggle d-flex align-items-center hidden-arrow"*/}
                    {/*    href="#"*/}
                    {/*    id="navbarDropdownMenuAvatar"*/}
                    {/*    role="button"*/}
                    {/*    data-mdb-toggle="dropdown"*/}
                    {/*    aria-expanded="false"*/}
                    {/*>*/}
                    {/*</a>*/}
                    <a onClick={() => {
                        keycloak.logout();
                        localStorage.clear();
                    }}>
                        <i className="fa-solid fa-power-off logout"></i>
                    </a>
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    onClick={() => keycloak.logout()}*/}
                    {/*>*/}
                    {/*    Logout*/}
                    {/*</button>*/}

                    {/*<ul*/}
                    {/*    className="dropdown-menu dropdown-menu-end"*/}
                    {/*    aria-labelledby="navbarDropdownMenuAvatar"*/}
                    {/*>*/}
                    {/*    <li>*/}
                    {/*        <a className="dropdown-item" href="#">My profile</a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a className="dropdown-item" href="#">Settings</a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a className="dropdown-item" href="#">Logout</a>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
